export class CourseLogo {
  constructor() {}
  public id: number;
  public nameNl: string;
  public nameEn: string;
  public logo: string;
  public sortorder: number;
}
